<template>
  <Details
    title="lease"
    resource="leases"
    :base-path="basePath"
    data-provider="$raaDataProvider"
  >
    <template v-slot:side-panel>
      <DetailsSidePanel entity-title="lease" new-entity></DetailsSidePanel>
    </template>
    <template v-slot:default="detailsProps">
      <LeaseForm
        :initial-values="initialValues"
        :on-submit="detailsProps.handleSubmit"
        :loading="detailsProps.loading"
        @close="detailsProps.redirectToList"
      />
    </template>
  </Details>
</template>

<script>
  import Details from "@/components/auth/details/Details";
  import DetailsSidePanel from "@/components/auth/details/DetailsSidePanel";
  import LeaseForm from "@/views/auth/raa-devtools/leases/LeaseForm";
  import ModalNavigation from "@/mixins/ModalNavigation";
  import {v4} from "uuid";

  export default {
    name: "LeaseCreate",
    components: {
      Details,
      DetailsSidePanel,
      LeaseForm,
    },
    mixins: [ModalNavigation],
    computed: {
      basePath: function () {
        return this.$route.name.replace('create', 'index');
      },
      initialValues() {
        return {
          id: v4()
        }
      },
    },
  }
</script>

<style scoped>

</style>
